import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminLanguage } from '../AdminLanguageContext';
import api from '../api';
import './Login.css';

const showDefaultLoginHint = process.env.NODE_ENV !== 'production'
  && process.env.REACT_APP_SHOW_ADMIN_DEFAULT_LOGIN_HINT === 'true';
const defaultAdminEmail = process.env.REACT_APP_DEFAULT_ADMIN_EMAIL || 'admin@oblitrok.com';

export default function Login() {
  const navigate = useNavigate();
  const { copy } = useAdminLanguage();
  const loginCopy = copy.login;
  const [form, setForm] = useState({ email: '', password: '' });
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [pendingToken, setPendingToken] = useState('');
  const [passwordForm, setPasswordForm] = useState({ newPassword: '', confirmNewPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/users/login', form);
      if (res.data.user?.role !== 'admin') {
        setError(loginCopy.noAdminPermission);
        return;
      }
      if (res.data.user?.mustChangePassword) {
        setPendingToken(res.data.token);
        setMustChangePassword(true);
        setPasswordForm({ newPassword: '', confirmNewPassword: '' });
        return;
      }
      localStorage.setItem('admin_token', res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || loginCopy.failed);
    } finally {
      setLoading(false);
    }
  };

  const handleForcedPasswordChange = async (e) => {
    e.preventDefault();
    setError('');
    if (passwordForm.newPassword !== passwordForm.confirmNewPassword) {
      setError(loginCopy.passwordMismatch);
      return;
    }
    setLoading(true);
    try {
      await api.put('/users/me/password', {
        currentPassword: form.password,
        newPassword: passwordForm.newPassword,
      }, {
        headers: { Authorization: `Bearer ${pendingToken}` },
      });
      localStorage.setItem('admin_token', pendingToken);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || loginCopy.passwordChangeFailed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span>Oblitrok</span>
        </div>
        {mustChangePassword ? (
          <>
            <h2>{loginCopy.forcePasswordTitle}</h2>
            <p>{loginCopy.forcePasswordDescription}</p>
            <form onSubmit={handleForcedPasswordChange}>
              <div className="form-group">
                <label>{loginCopy.newPassword}</label>
                <input
                  type="password"
                  value={passwordForm.newPassword}
                  onChange={e => setPasswordForm(f => ({ ...f, newPassword: e.target.value }))}
                  placeholder={loginCopy.passwordPlaceholder}
                />
              </div>
              <div className="form-group">
                <label>{loginCopy.confirmNewPassword}</label>
                <input
                  type="password"
                  value={passwordForm.confirmNewPassword}
                  onChange={e => setPasswordForm(f => ({ ...f, confirmNewPassword: e.target.value }))}
                  placeholder={loginCopy.confirmNewPassword}
                />
              </div>
              {error && <p className="error-msg">{error}</p>}
              <button type="submit" className="btn btn-primary login-btn" disabled={loading || !pendingToken}>
                {loading ? loginCopy.changingPassword : loginCopy.confirmChangePassword}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2>{loginCopy.title}</h2>
            <p>{loginCopy.subtitle}</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>{loginCopy.email}</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="admin@oblitrok.com"
                />
              </div>
              <div className="form-group">
                <label>{loginCopy.password}</label>
                <input
                  type="password"
                  value={form.password}
                  onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  placeholder={loginCopy.passwordPlaceholder}
                />
              </div>
              {error && <p className="error-msg">{error}</p>}
              <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
                {loading ? loginCopy.loading : loginCopy.login}
              </button>
            </form>
          </>
        )}
        {showDefaultLoginHint && (
          <div className="login-hint">
            {loginCopy.localDefaultEmail}: {defaultAdminEmail}
          </div>
        )}
      </div>
    </div>
  );
}
